import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
  tone?: 'onDark' | 'onLight';
};
export function SectionHeading({
  id,
  children,
  className = '',
  tone = 'onDark'
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-216" data-mp="vxjnrfuw76d1">
      <h2 id={id} className={`mx-auto max-w-3xl text-balance text-3xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl ${tone === 'onDark' ? 'text-ivory' : 'text-navy'}`} data-id="element-217" data-mp="ryav6ebl9ej2">
        {children}
      </h2>
      <span className="mx-auto mt-4 flex w-fit items-center gap-1" aria-hidden="true" data-id="element-218" data-mp="i6wva5fq6cpe">
        <span className="h-1 w-10 rounded-full bg-gold" data-id="element-219" data-mp="d83m2p7h17v1" />
        <span className={`h-1 w-3 rounded-full ${tone === 'onDark' ? 'bg-ivory/40' : 'bg-navy/30'}`} data-id="element-220" data-mp="d6im2k2e0wps" />
      </span>
    </div>;
}